import Box from "@mui/material/Box";
import MuiButton, {
  type ButtonProps as MuiButtonProps,
} from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { darken, useTheme } from "@mui/material/styles";
import { colors } from "@covertree/theme/colors";

type ButtonCustomColorVariant = "warning" | "error";

export interface BaseButtonProps extends MuiButtonProps {
  loading?: boolean;
  customColorVariant?: ButtonCustomColorVariant;
}

export const BaseButton = ({
  customColorVariant,
  loading,
  variant,
  ...props
}: BaseButtonProps) => {
  const theme = useTheme();

  return (
    <Box
      position="relative"
      display="inline-flex"
      width={props.fullWidth ? "100%" : "inherit"}>
      <MuiButton
        sx={{
          ...(customColorVariant === "error"
            ? {
                "&.MuiButton-contained": {
                  backgroundColor: `${colors.red1} !important`,
                  color: theme.palette.common.white,
                  "&:hover": {
                    backgroundColor: `${darken(colors.red1, 0.1)} !important`,
                  },
                },
                "&.MuiButton-outlined": {
                  borderColor: colors.red1,
                  color: colors.red1,
                  "&:hover": {
                    backgroundColor: colors.red1,
                    color: theme.palette.common.white,
                  },
                },
              }
            : {}),
          ...(customColorVariant === "warning"
            ? {
                "&.MuiButton-contained": {
                  backgroundColor: colors.orange1,
                  color: theme.palette.common.white,
                  "&:hover": {
                    backgroundColor: darken(colors.orange1, 0.1),
                  },
                },
                "&.MuiButton-outlined": {
                  borderColor: colors.orange1,
                  color: colors.orange1,
                  "&:hover": {
                    backgroundColor: colors.orange1,
                    color: theme.palette.common.white,
                  },
                },
              }
            : {}),
        }}
        variant={variant}
        {...props}
      />
      {loading && (
        <Box
          display="flex"
          position="absolute"
          sx={{
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}>
          <CircularProgress
            sx={{
              color: variant === "outlined" ? "primary.main" : "common.white",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default BaseButton;
